import configureStore from './configureStore'
import history from './Utils/history'

// Create redux store
const initialState = {}
export const store = configureStore(initialState, history)